export const NOT_AUTHORIZED_STATUS = [401, 403]
export const NOT_AUTHORIZED = "NotAuthorized"
export const MOBILE_BREAKPOINT = 780;

// The /get device-routed store redirect (reInvent QR target): a single URL that sends a visitor to
// the right AWS Card Clash store listing by device.
export const APPLE_APP_STORE_URL = "https://apps.apple.com/us/app/aws-card-clash/id6745035578";
export const GOOGLE_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.amazon.aws.cardclash";
// The URL the printed QR encodes (resolves to the /get route below).
export const GET_REDIRECT_URL = "https://cardclash.skillbuilder.aws/get";